import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import SessionsListPage from './SessionsListPage';
import SessionManager from './SessionManager';
import { jsx as _jsx } from "react/jsx-runtime";
function EventSessionsManager(_ref) {
  var eventId = _ref.eventId,
    inContentManagerContext = _ref.inContentManagerContext,
    inAssetManagerContext = _ref.inAssetManagerContext;
  var location = useLocation();
  var _queryparse = queryparse(location.search),
    sessionId = _queryparse.sessionId;
  if (sessionId) {
    return /*#__PURE__*/_jsx(SessionManager, {
      inAssetManagerContext: inAssetManagerContext,
      inContentManagerContext: inContentManagerContext,
      sessionId: sessionId
    });
  }
  return /*#__PURE__*/_jsx(SessionsListPage, {
    eventId: eventId
  });
}
export default EventSessionsManager;
export * from './SessionManager/utils';